import * as transformers from '@attain-apps/transformers'

// TODO: maybe rename `IN` and `OUT` to `In` and `Out`

export const IN = new transformers.Factory('gql')
export namespace IN {
  export type OutputType =
    typeof IN extends transformers.Factory<infer TOutputType>
      ? TOutputType
      : never
  export type Transformer<TGql, TEntity> = transformers.Transformer<
    OutputType,
    TGql,
    TEntity
  >
}

export const OUT = new transformers.Factory('entity')
export namespace OUT {
  export type OutputType =
    typeof OUT extends transformers.Factory<infer TOutputType>
      ? TOutputType
      : never
  export type Transformer<TGql, TEntity> = transformers.Transformer<
    OutputType,
    TGql,
    TEntity
  >
}
